import React, {FunctionComponent, useMemo} from "react";
import { useAuth } from "../../services/auth/auth-provider";

interface HeaderProps {}

const Header: FunctionComponent<HeaderProps> = (props) => {
  const vm = useVM(props);

  return (
    <div className='items-center justify-between flex container mx-auto px-2 pt-4'>
      <h1 className='text-4xl'>Scales</h1>

      {
        vm.name && 
        <div className='flex justify-end'>
          <span>Logged in as {vm.name}</span>
        </div>
      }

      {
        !vm.isAuthenticated &&
        <div className='flex justify-end'>
          <button
            className='border border-blue-500 px-4 py-2 rounded shadow-md text-blue-500 hover:shadow-outline'
            onClick={vm.login}
          >Login</button>
        </div>
      }
    </div>
  )
}

function useVM({}: HeaderProps) {
  const {isAuthenticated, login, user} = useAuth();

  return {
    isAuthenticated,
    login,
    name: user?.name,
  }
}

export default Header;
